import clsx from 'clsx';
import { createContext, type FC, lazy, type PropsWithChildren, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Button } from '@furality/furality-purpose';
import style from '@/components/__app/PageLoadingProvider.module.scss';

const InfinityLoader = lazy(() => import('@/components/loading/InfinityLoader.tsx'));

type PageLoadingState = {
  startLoading: () => void;
  stopLoading: () => void;
};
export const PageLoadingContext = createContext<PageLoadingState>({
  startLoading: () => undefined,
  stopLoading: () => undefined,
});

// TODO: make used "spinner" replaceable
type PageLoadingProviderProps = {
  defaultState?: boolean;
};
const PageLoadingProvider: FC<PropsWithChildren<PageLoadingProviderProps>> = ({
  children,
  defaultState = false,
}) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(defaultState);
  const [sorry, setSorry] = useState(false);

  useEffect(() => {
    if (!show) {
      return;
    }

    const timeoutId = setTimeout(() => {
      setSorry(true);
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [show]);

  return (
    <>
      <div className={clsx('h-100vh', style['container'], style['fadeOut'], show || style['hide'])}>
        <Row className="align-items-center h-100">
          <Col md={6} className="offset-md-3">
            <div className={style['inner-loader']}>
              <InfinityLoader />
              {sorry && (
                <p className="text-white sorry">
                  {t('shared.loading.slower_than_expected')}
                  <br />{' '}
                  <Button onClick={() => window.location.reload()}>
                    {t('shared.loading.refresh')}
                  </Button>
                </p>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <PageLoadingContext.Provider
        value={{
          startLoading: () => setShow(true),
          stopLoading: () => setShow(false),
        }}
      >
        {children}
      </PageLoadingContext.Provider>
    </>
  );
};

export default PageLoadingProvider;
